import React, { useEffect, useState } from 'react';
import { Video, Check, AlertTriangle, Loader2, Link2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Carte admin : connecte le webhook Calendly pour synchroniser auto. la "Prochaine visio" des clients. */
export const CalendlyConnect = ({ csrfToken }) => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const loadStatus = () => {
    fetch(`${BACKEND_URL}/api/admin/calendly/status?origin_url=${encodeURIComponent(window.location.origin)}`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setStatus)
      .catch(() => setStatus({ connected: false, reason: 'error' }));
  };

  useEffect(() => { loadStatus(); }, []);

  const connect = () => {
    setBusy(true); setError('');
    fetch(`${BACKEND_URL}/api/admin/calendly/connect`, {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken },
      body: JSON.stringify({ origin_url: window.location.origin }),
    })
      .then((r) => (r.ok ? r.json() : r.json().then((j) => Promise.reject(j))))
      .then(() => loadStatus())
      .catch((j) => setError(j?.detail || 'Connexion Calendly impossible.'))
      .finally(() => setBusy(false));
  };

  if (!status) return null;

  const webhookConnected = status.connected && status.current_host_connected === true;

  return (
    <div className="rounded-2xl bg-zinc-900 border border-white/10 p-4 mb-5 flex flex-wrap items-center justify-between gap-3" data-testid="calendly-connect-card">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-purple-500 to-primary flex items-center justify-center shrink-0">
          <Video className="w-4.5 h-4.5 text-white" />
        </div>
        <div>
          <p className="font-bold text-white text-sm">Synchronisation Calendly</p>
          {status.connected ? (
            <p className="text-xs text-zinc-400">
              Compte : <span className="text-white">{status.calendly_email}</span> ·{' '}
              {webhookConnected ? (
                <span className="text-emerald-400 inline-flex items-center gap-1"><Check className="w-3 h-3" /> Visio auto-synchronisée</span>
              ) : (
                <span className="text-amber-400">Webhook non connecté sur cet environnement</span>
              )}
            </p>
          ) : (
            <p className="text-xs text-amber-400 inline-flex items-center gap-1"><AlertTriangle className="w-3 h-3" /> {status.reason === 'invalid_token' ? 'Token Calendly invalide' : 'Non connecté'}</p>
          )}
        </div>
      </div>
      {!webhookConnected && (
        <button onClick={connect} disabled={busy} className="inline-flex items-center gap-2 text-xs font-bold text-white bg-gradient-to-r from-purple-500 to-primary rounded-xl px-4 py-2 hover:scale-105 active:scale-95 transition-transform disabled:opacity-60" data-testid="calendly-connect-button">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Link2 className="w-3.5 h-3.5" />} {busy ? 'Connexion…' : 'Connecter Calendly'}
        </button>
      )}
      {error && <p className="text-xs text-red-400 w-full" data-testid="calendly-connect-error">{error}</p>}
    </div>
  );
};

export default CalendlyConnect;
